var map = {
	"./CGHub_Logo.png": 6109,
	"./CGHub_Logo_icon.png": 5414,
	"./Electricity.png": 3100,
	"./Neutral Markets Logo - Light.png": 6431,
	"./Neutral Markets Logo.png": 4828,
	"./Neutral Markets Logomark - Light.png": 6048,
	"./Neutral Markets Logomark.png": 8281,
	"./marketdata.jpeg": 6344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 524;